// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  MenuOutlined, CategoryOutlined, BurstModeOutlined, DoDisturbOutlined, EditNoteOutlined, Filter,
  AutoAwesomeMotionOutlined, Category, Assessment
} from '@mui/icons-material';
import enums from 'utils/enums';

// icons
const icons = {
  MenuOutlined,
  CategoryOutlined,
  BurstModeOutlined,
  DoDisturbOutlined,
  EditNoteOutlined,
  Filter,
  AutoAwesomeMotionOutlined,
  Category,
  Assessment
};

// ==============================|| MENU ITEMS - MAIN ||============================== //
const inventory = {
  id: 'inventory',
  type: 'group',
  title: <FormattedMessage id='inventory' />,
  roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin, enums.userRole.SiteManager, enums.userRole.User],
  children: [
    {
      id: 'polist',
      title: <FormattedMessage id='poList' />,
      subTitle: 'Manage Purchase Orders',
      type: 'item',
      url: 'inventory/polist',
      icon: icons.Category,
      isShowFilter: true,
      showTitle: true
    },
    {
      id: 'physicalstock',
      title: <FormattedMessage id='physicalStock' />,
      subTitle: 'Stocktake',
      type: 'item',
      url: 'inventory/physical-stock',
      icon: icons.Category,
      isShowFilter: true,
      showTitle: true
    },
    {
      id: 'wastage',
      title: <FormattedMessage id='wastage' />,
      subTitle: 'Wastage',
      type: 'item',
      url: 'inventory/wastage',
      icon: icons.Category,
      isShowFilter: true,
      showTitle: true
    },
    {
      id: 'stockReport',
      title: <FormattedMessage id='stockReport' />,
      subTitle: 'Stock Usage Report',
      type: 'item',
      url: 'inventory/stock-report',
      icon: icons.Assessment,
      isShowFilter: true,
      showTitle: true
    },
  ]
};

export default inventory;
